<template>
    <div>
        <h2>{{$translate('Membership')}}</h2>

        <div v-for="user in membershipStillRequired" :key="user.id" class="py-2">
            {{ membershipText(user) }}

            <simple-product-list :products="membershipsToBuy" @buy="onBuyMembership($event, user)" buy-button-text="Välj"  />
        </div>

        <div v-if="membershipStillRequired.length == 0">
            {{$translate('Done! Membership added')}}
        </div>
    </div>
</template>

<script>
import SimpleProductList from '../views/SimpleProductList.vue'
export default {
    name: 'zoezi-membership-checkout',

    props: ['items', 'cartName'],

    components: {
        SimpleProductList
    },

    computed: {
        products() {
            return this.$store.getters.allProducts;
        },
        membershipRequiredForUsers() {
            return this.$booking.getUsersWhichRequireMembership(this.items);
        },
        membershipRequired() {
            return this.membershipRequiredForUsers.length > 0;
        },
        users() {
            let users = [];
            if (!this.$store.state.user) {
                return [];
            }
            users.push(this.$store.state.user)
            this.$store.state.user.canManage.forEach(x => {
                users.push(x);
            })
            return users;
        },
        membershipStillRequired() {
            return this.membershipRequiredForUsers.filter(user_id => {
                let membershipsInBasket = this.items.find(item => item.product.membership && item.users.includes(user_id));
                return !membershipsInBasket;
            }).map(id => this.users.find(u => u.id == id))
        },
        membershipsToBuy() {
            return this.products?.filter(x => x.membership);
        }
    },
    methods: {
        onBuyMembership(product, user) {
            if (this.cartName != null) {
                let existing = this.items.find(x => x.product_id == product.id);
                if (existing) {
                    this.$store.dispatch('changeItemCountInCart', {cartName: this.cartName, product_id: product.id, count: existing.count + 1 })
                    let users = existing.users.concat();
                    users.push(user.id);
                    this.$store.dispatch('changeItemUsersInCart', {cartName: this.cartName, product_id: product.id, users})
                } else {
                    this.$store.dispatch('addToCart', {cartName: this.cartName, product_id: product.id, count: 1, site_id: this.$store.getters.selectedSiteId})
                    this.$store.dispatch('changeItemUsersInCart', {cartName: this.cartName, product_id: product.id, users: [user.id]})
                }
            } else {
                this.$emit('buy', product, user);
            }
        },
        membershipText(user) {
            if (user.id == this.$store.state.user.id) {
                return this.$translate('You need to purchase a membership');
            } else {
                return this.$translate('{0} needs to buy a membership').format(user.name.split(' ')[0]);
            }
        }
    },
    mounted() {
        this.$store.dispatch('loadProducts');
    }
}
</script>
